import { BoxProps } from '@jfs/ui-new'
import { Dimensions, StyleSheet } from 'react-native'
import { CarousalDimens, ListDimens } from '../../utils/utils'
import { ImageProps } from '../ImageNew'
import { TextProps } from '../TextNew'
const { width } = Dimensions.get('screen')

const ListItem = {
  // Width and Height
  LISTITEM_DEFAULT_VERTICAL_WIDTH: '100%',
  LISTITEM_IMAGE_SIZE: 50,
  LISTITEM_CHECKBOX_SIZE: 25,
  LISTITEM_SMALL_IMAGE_HEIGHT: 88,
  LISTITEM_IMAGE_HEIGHT: 150,
  LISTITEM_SUB_CONTENT_CONTAINER_HEIGHT: 30,
  LISTITEM_THREE_LINE_IMAGE_SIZE: 60,
  LISTITEM_THREE_LINE_IMAGE_COUNTER_HEIGHT: 80,
  LISTITEM_BANKLIST_ITEM_HEIGHT: 70,
  LISTITEM_ONE_LINE_NO_VALUE_HEIGHT: 56,

  // Border Width and Radius
  LISTITEM_SMALL_IMAGE_BORDER_RADIUS: 5,
  LISTITEM_IMAGE_DESC_BORDER_RADIUS: 5,
  LISTITEM_THREE_COLUMN_BORDER_RADIUS: 5,
  LISTITEM_THREE_LINE_IMAGE_COUNTER_BORDER_WIDTH: 0.5,
  LISTITEM_THREE_LINE_IMAGE_COUNTER_BORDER_RADIUS: 5,
  LISTITEM_THREE_LINE_IMAGE_BORDER_RADIUS: 5,
  // Padding and Margins
  LISTITEM_DEFAULT_HORIZONTAL_MARGIN: 5,
  LISTITEM_DEFAULT_HORIZONTAL_TEXT_PADDING: 10,
  LISTITEM_DEFAULT_HORIZONTAL_BOTTOM_PADDING: 30,
  LISTITEM_DEFAULT_HORIZONTAL_LEFT: 0,
  LISTITEM_DEFAULT_VERTICAL_PADDING: 8,
  LISTITEM_ONE_LABEL_CONTAINER_PADDING: 0,
  LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN: 14,
  LISTITEM_DEFAULT_VERTICAL_COUNTER_MARGIN: 16,
  LISTITEM_SMALL_IMAGE_CONTAINER_MARGIN: 5,
  LISTITEM_IMAGE_DESC_CONTAINER_MARGIN: 5,
  LISTITEM_ONELINE_LABEL_TEXT_MARGIN: 30,
  LISTITEM_THREE_LINE_TITLE_TEXT_PADDING: 4,
  LISTITEM_THREE_LINE_IMAGE_COUNTER_MARGIN: 8,
  LISTITEM_THREE_LINE_IMAGE_COUNTER_PADDING: 6,
  LISTITEM_THREE_LINE_IMAGE_SELECTABLE_COUNTER_MARGIN: 26,
  LISTITEM_TITLETEXT_PADDING: 2,
  LISTITEM_THREE_LINE_IMAGE_TITLE_MARGIN: 4,
  LISTITEM_FOOTER_ADDRESS_PADDING: 16,
  LISTITEM_BANKLIST_TITLETEXT_PADDING: 2,
  LISTITEM_BANKLIST_ITEM_TITLETEXT_PADDING: 4,
  LISTITEM_ADDRESSLINE_PADDING: 16,
  LISTITEM_ADDRESSLINE_TITLETEXT_MARGIN: 8,
  LISTITEM_SUBCONENT_CONTAINER_MARGIN: 18,
  LISTITEM_SUBCONENT_TITLETEXT_PADDING: 2,
  LISTITEM_SUBCONENT_CONTAINER_PADDING: 8,
}

const MarginDimens = {
  MARGIN_ZERO: 0,
  MARGIN_2_PX: 0,
  MARGIN_SMALL: 4,
  MARGIN_MIN: 8,
  MARGIN_MIN_PLUS: 10,
  MARGIN_MAX: 16,
  MARGIN_EXTRA_MAX: 20,
  MARGIN_LARGE: 24,
  MARGIN_END: 30,
  MARGIN_40: 40,
  MARGIN_50: 50,
  MARGIN_96: 96,
}

const HEIGHT = {
  HEIGHT_80: 80,
  HEIGHT_48: 48,
  HEIGHT_16: 16,
  HEIGHT_200: 200,
  HEIGHT_100: 100,
  HEIGHT_64: 64,
}

const shadow = {
  backgroundColor: 'white',
  shadowColor: 'black',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.2,
  shadowRadius: 4,
  elevation: 2,
}

const DefaultHorizontalStyle = {
  containerStyle: {
    position: 'relative',
    margin: ListItem.LISTITEM_DEFAULT_HORIZONTAL_MARGIN,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  titleTextStyle: {
    backgroundColor: 'BLACK_LIGHT',
    color: 'WHITE',
    position: 'absolute',
    padding: ListItem.LISTITEM_DEFAULT_HORIZONTAL_TEXT_PADDING,
    bottom: ListItem.LISTITEM_DEFAULT_HORIZONTAL_BOTTOM_PADDING,
    width: width - 20,
    left: ListItem.LISTITEM_DEFAULT_HORIZONTAL_LEFT,
  } as BoxProps,
}

const DefaultVerticalStyle = {
  superContainerStyle: {
    flex: 1,
    flexDirection: 'column',
  } as BoxProps,
  containerStyle: {
    width: ListItem.LISTITEM_DEFAULT_VERTICAL_WIDTH,
    paddingLeft: ListItem.LISTITEM_DEFAULT_VERTICAL_PADDING,
    paddingRight: ListItem.LISTITEM_DEFAULT_VERTICAL_PADDING,
    flexDirection: 'row',
    backgroundColor: 'WHITE',
  } as BoxProps,
  imageContainerStyle: {
    marginLeft: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
    marginRight: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
    justifyContent: 'center',
  } as BoxProps,
  contentContainerStyle: {
    margin: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
    justifyContent: 'space-between',
    // //flex: 1,
    // flexShrink: 1,
  } as BoxProps,
  selectableContainerStyle: {
    marginLeft: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
    marginRight: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
    justifyContent: 'center',
  } as BoxProps,
  selectableCounterStyle: {
    marginLeft: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
    marginRight: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
    marginTop: ListItem.LISTITEM_DEFAULT_VERTICAL_COUNTER_MARGIN,
    justifyContent: 'center',
  } as BoxProps,
  titleTextStyle: {
    color: 'BLACK',
    fontWeight: 'FONT_WEIGHT_BOLD',
  } as TextProps,
  valueTextStyle: {
    color: 'BLACK',
    fontWeight: 'FONT_WEIGHT_LIGHT',
  } as TextProps,
  imageStyle: {
    width: ListItem.LISTITEM_IMAGE_SIZE,
    height: ListItem.LISTITEM_IMAGE_SIZE,
    resizeMode: 'center',
  } as ImageProps,
  selectableStyle: {
    width: ListItem.LISTITEM_CHECKBOX_SIZE,
    height: ListItem.LISTITEM_CHECKBOX_SIZE,
  } as ImageProps,
  subContent1ContainerStyle: {
    flexDirection: 'row',
  } as BoxProps,
  subContent2ContainerStyle: {
    justifyContent: 'center',
    alignItems: 'flex-end',
  } as BoxProps,
  value1TextStyle: {
    fontWeight: 'FONT_WEIGHT_LIGHT',
    fontSize: 'FONT_SIZE_SMALL',
    color: 'SECONDARY_GREY',
    marginBottom: ListDimens.LIST_HEADER_CONTAINER_PADDING,
  } as TextProps,
  value2TextStyle: {
    color: 'SECONDARY_GREY',
    fontWeight: 'FONT_WEIGHT_LIGHT',
    fontSize: 'FONT_SIZE_SMALL',
  } as TextProps,
  value3TextStyle: {
    color: 'BLACK',
    fontWeight: 'FONT_WEIGHT_BOLD',
    fontSize: 'FONT_SIZE_LARGE',
  } as TextProps,
  value4TextStyle: {
    color: 'BLACK_LIGHT',
    fontWeight: 'FONT_WEIGHT_LIGHT',
    fontSize: 'FONT_SIZE_SMALL',
  } as TextProps,
  value5TextStyle: {
    color: 'BLACK',
    fontWeight: 'FONT_WEIGHT_BOLD',
    fontSize: 'FONT_SIZE_LARGE',
  } as TextProps,
  value6TextStyle: {
    color: 'BLACK',
    fontWeight: 'FONT_WEIGHT_BOLD',
    fontSize: 'FONT_SIZE_LARGE',
  } as TextProps,
  iconStyle: 'PRIMARY',
  iconSize: 'FONT_SIZE_EXTRA_LONG',
  transParentStyle: {
    height: 65,
    width: '100%',
    //flex: 1,
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'BLACK',
    opacity: 0.4,
    marginBottom: 8,
  } as BoxProps,
  absoluteText: {
    position: 'absolute',
    color: 'WHITE',
  } as TextProps,
  selectedTitleTextStyle: {} as TextProps,
  selectedContainerStyle: {
    width: ListItem.LISTITEM_DEFAULT_VERTICAL_WIDTH,
    paddingLeft: ListItem.LISTITEM_DEFAULT_VERTICAL_PADDING,
    paddingRight: ListItem.LISTITEM_DEFAULT_VERTICAL_PADDING,
    flexDirection: 'row',
    backgroundColor: 'WHITE',
  } as BoxProps,
}

const styles = {
  SmallImages: {
    ...DefaultVerticalStyle,
    imageStyle: {
      width: width - 50,
      borderRadius: ListItem.LISTITEM_SMALL_IMAGE_BORDER_RADIUS,
      height: ListItem.LISTITEM_SMALL_IMAGE_HEIGHT,
      resizeMode: 'cover',
    } as ImageProps,
    containerStyle: {
      margin: ListItem.LISTITEM_SMALL_IMAGE_CONTAINER_MARGIN,
      height: ListItem.LISTITEM_SMALL_IMAGE_HEIGHT,
    } as BoxProps,
    titleTextStyle: { color: 'TRANSPARENT' } as TextProps,
  },
  CarouselFullWithDots: {
    ...DefaultVerticalStyle,
    imageStyle: {
      width: width - 32,
      borderRadius: CarousalDimens.CAROUSAL_BORDER_RADIUS,
      height: CarousalDimens.CAROUSAL_FULL_HEIGHT,
    } as ImageProps,
    containerStyle: {
      ...shadow,
      margin: CarousalDimens.CAROUSAL_FULL_MARGIN,
      height: CarousalDimens.CAROUSAL_FULL_HEIGHT,
    } as BoxProps,
  },
  CarouselFullScreen: {
    ...DefaultVerticalStyle,
    imageStyle: {
      height: CarousalDimens.CAROUSAL_FULL_IMAGE_HEIGHT,
    } as ImageProps,
    containerStyle: {
      height: CarousalDimens.CAROUSAL_FULL_IMAGE_HEIGHT,
    } as BoxProps,
  },
  CarouselSmallImages: {
    ...DefaultVerticalStyle,
    imageStyle: {
      resizeMode: 'cover',
      width: CarousalDimens.CAROUSAL_SMALL_WIDTH,
      borderRadius: CarousalDimens.CAROUSAL_BORDER_RADIUS,
      height: CarousalDimens.CAROUSAL_SMALL_HEIGHT,
    } as ImageProps,
    imageContainerStyle: {
      //flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    } as BoxProps,
    containerStyle: {
      borderRadius: CarousalDimens.CAROUSAL_BORDER_RADIUS,
      margin: CarousalDimens.CAROUSAL_SMALL_MARGIN,
      height: CarousalDimens.CAROUSAL_SMALL_HEIGHT,
    } as BoxProps,
    titleTextStyle: { color: 'TRANSPARENT' } as TextProps,
  },
  CarouselLabel: {
    ...DefaultVerticalStyle,
    containerStyle: {
      borderRadius: CarousalDimens.CAROUSAL_LABEL_BORDER_RADIUS,
      height: CarousalDimens.CAROUSAL_LABEL_HEIGHT,
      backgroundColor: 'PRIMARY',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: CarousalDimens.CAROUSAL_LABEL_MARGIN,
      paddingHorizontal: CarousalDimens.CAROUSAL_LABEL_PADDING_HORIZONTAL,
    } as BoxProps,
    titleTextStyle: {
      color: 'WHITE',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
    superContainerStyle: {} as BoxProps,
    contentContainerStyle: {} as BoxProps,
  },
  CarouselAge: {
    ...DefaultVerticalStyle,
    containerStyle: {
      height: CarousalDimens.CAROUSAL_AGE_SIZE,
      width: CarousalDimens.CAROUSAL_AGE_SIZE,
      backgroundColor: 'WHITE',
      borderRadius: 4,
      justifyContent: 'center',
      alignItems: 'center',
      marginHorizontal: CarousalDimens.CAROUSAL_AGE_MARGIN_HORIZONTAL,
    } as BoxProps,
    titleTextStyle: {
      color: 'DARK_GREY',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
    superContainerStyle: {} as BoxProps,
    contentContainerStyle: {} as BoxProps,
    selectedContainerStyle: {
      height: CarousalDimens.CAROUSAL_AGE_SIZE,
      width: CarousalDimens.CAROUSAL_AGE_SIZE,
      backgroundColor: 'PRIMARY',
      borderRadius: 4,
      justifyContent: 'center',
      alignItems: 'center',
      marginHorizontal: CarousalDimens.CAROUSAL_AGE_MARGIN_HORIZONTAL,
    } as BoxProps,
    selectedTitleTextStyle: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_BOLD',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
  },
  Carousel: DefaultVerticalStyle,
  CarouselScrollableData: DefaultVerticalStyle,
  ImageDesc: {
    ...DefaultVerticalStyle,
    imageStyle: {
      borderRadius: ListItem.LISTITEM_IMAGE_DESC_BORDER_RADIUS,
      width: width - 20,
      height: ListItem.LISTITEM_IMAGE_HEIGHT,
    } as ImageProps,
    titleTextStyle: DefaultHorizontalStyle.titleTextStyle,
    containerStyle: {
      margin: ListItem.LISTITEM_IMAGE_DESC_CONTAINER_MARGIN,
      height: ListItem.LISTITEM_IMAGE_HEIGHT,
    } as BoxProps,
  },
  ThreeColumn: {
    ...DefaultVerticalStyle,
    imageStyle: {
      borderRadius: ListItem.LISTITEM_THREE_COLUMN_BORDER_RADIUS,
      width: width / 3 - 10,
      height: ListItem.LISTITEM_IMAGE_HEIGHT,
    } as ImageProps,
    containerStyle: DefaultHorizontalStyle.containerStyle,
    titleTextStyle: {
      ...DefaultHorizontalStyle.titleTextStyle,
      width: width / 3 - 10,
    } as BoxProps,
  },
  /** *** vertical styles****** */
  Default: DefaultVerticalStyle,
  OneLineOneLabel: {
    ...DefaultVerticalStyle,
    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      alignItems: 'center',
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontWeight: 'FONT_WEIGHT_MEDIUM',
    } as TextProps,

    imageContainerStyle: {
      ...DefaultVerticalStyle.imageContainerStyle,
      marginRight: 0,
      paddingLeft: 6,
    } as BoxProps,

    contentContainerStyle: {
      margin: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
      justifyContent: 'space-between',
    } as BoxProps,
    iconStyle: 'BLACK',
    iconSize: 'FONT_SIZE_EXTRA_LARGE',
  },
  OneLineMediumStyle: {
    ...DefaultVerticalStyle,
    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      alignItems: 'center',
      height: ListItem.LISTITEM_ONE_LINE_NO_VALUE_HEIGHT,
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      color: 'BLACK',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      fontSize: 'FONT_SIZE_LARGE',
    } as TextProps,
  },
  TwoLabelTwoValue: {
    ...DefaultVerticalStyle,

    superContainerStyle: {
      //flex: 1,
      flexDirection: 'column',
    } as BoxProps,

    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      margin: MarginDimens.MARGIN_MAX,
      flexDirection: 'row',
    } as BoxProps,

    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      flexDirection: 'column',
    } as BoxProps,

    titleTextStyle: {
      color: 'BLACK',
      fontSize: 'FONT_SIZE_MEDIUM',
      fontWeight: 'FONT_WEIGHT_LIGHT',
    } as TextProps,

    bottomContainerStyle: {
      margin: ListDimens.LIST_BOTTOM_CONTAINER_MARGIN,
      marginRight: MarginDimens.MARGIN_ZERO,
      marginTop: MarginDimens.MARGIN_ZERO,
    } as BoxProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontWeight: 'FONT_WEIGHT_BOLD',
      fontSize: 'FONT_SIZE_MEDIUM',
      color: 'SECONDARY_GREY',
    } as TextProps,

    value3TextStyle: {
      ...DefaultVerticalStyle.value3TextStyle,
      color: 'BLACK',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,

    imageContainerStyle: {
      ...DefaultVerticalStyle.imageContainerStyle,
      marginLeft: 0,
      marginRight: 0,
      justifyContent: 'flex-start',
    } as BoxProps,

    imageStyle: {
      ...DefaultVerticalStyle.imageStyle,
      marginTop: ListItem.LISTITEM_ADDRESSLINE_TITLETEXT_MARGIN,
    } as ImageProps,

    selectableContainerStyle: {
      ...DefaultVerticalStyle.selectableContainerStyle,
      marginTop: ListItem.LISTITEM_ADDRESSLINE_PADDING,
      justifyContent: 'flex-start',
    } as BoxProps,
  },
  TwoLabelTwoValueWithErrorInfo: {
    ...DefaultVerticalStyle,
    superContainerStyle: {
      //flex: 1,
      flexDirection: 'column',
    } as BoxProps,

    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      margin: MarginDimens.MARGIN_MAX,
      flexDirection: 'row',
    } as BoxProps,

    bottomContainerStyle: {
      margin: ListDimens.LIST_BOTTOM_CONTAINER_MARGIN,
      marginRight: MarginDimens.MARGIN_ZERO,
      marginTop: MarginDimens.MARGIN_ZERO,
    } as BoxProps,

    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      flexDirection: 'column',
    } as BoxProps,

    titleTextStyle: {
      color: 'BLACK',
      fontSize: 'FONT_SIZE_MEDIUM',
      fontWeight: 'FONT_WEIGHT_LIGHT',
    } as TextProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontWeight: 'FONT_WEIGHT_BOLD',
      fontSize: 'FONT_SIZE_MEDIUM',
      color: 'SECONDARY_GREY',
    } as TextProps,

    value3TextStyle: {
      ...DefaultVerticalStyle.value3TextStyle,
      color: 'BLACK',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,

    errorLabelViewStyle: {
      color: 'ERROR',
      fontSize: 'FONT_SIZE_SMALL',
    } as TextProps,

    imageContainerStyle: {
      ...DefaultVerticalStyle.imageContainerStyle,
      justifyContent: 'flex-start',
    } as BoxProps,

    imageStyle: {
      ...DefaultVerticalStyle.imageStyle,
      marginTop: ListItem.LISTITEM_ADDRESSLINE_TITLETEXT_MARGIN,
    } as ImageProps,

    selectableContainerStyle: {
      ...DefaultVerticalStyle.selectableContainerStyle,
      marginTop: ListItem.LISTITEM_ADDRESSLINE_PADDING,
      justifyContent: 'flex-start',
    } as BoxProps,
  },
  OneLineNoValue: {
    ...DefaultVerticalStyle,
    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      alignItems: 'center',
      height: ListItem.LISTITEM_ONE_LINE_NO_VALUE_HEIGHT,
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      color: 'BLACK',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      fontSize: 'FONT_SIZE_LARGE',
    } as TextProps,
  },
  OneLineLabelValue: {
    ...DefaultVerticalStyle,
    containerStyle: {
      width: ListItem.LISTITEM_DEFAULT_VERTICAL_WIDTH,
      paddingVertical: ListItem.LISTITEM_ONE_LABEL_CONTAINER_PADDING,
      flexDirection: 'row',
      backgroundColor: 'WHITE',
    } as BoxProps,

    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      alignItems: 'center',
      flexDirection: 'row',
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      color: 'SECONDARY_GREY',
      //flex: 1,
      fontSize: 'FONT_SIZE_SMALL',
      fontWeight: 'FONT_WEIGHT_LIGHT',
    } as TextProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontSize: 'FONT_SIZE_SMALL',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
    } as TextProps,
  },
  OneLineLabelValueWithPadding: {
    ...DefaultVerticalStyle,
    containerStyle: {
      width: ListItem.LISTITEM_DEFAULT_VERTICAL_WIDTH,
      paddingVertical: ListItem.LISTITEM_ONE_LABEL_CONTAINER_PADDING,
      paddingLeft: ListItem.LISTITEM_DEFAULT_VERTICAL_PADDING,
      paddingRight: ListItem.LISTITEM_DEFAULT_VERTICAL_PADDING,
      flexDirection: 'row',
      backgroundColor: 'WHITE',
    } as BoxProps,

    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      alignItems: 'center',
      flexDirection: 'row',
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      color: 'SECONDARY_GREY',
      //flex: 1,
      fontSize: 'FONT_SIZE_SMALL',
      fontWeight: 'FONT_WEIGHT_LIGHT',
    } as TextProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontSize: 'FONT_SIZE_SMALL',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
    } as TextProps,
  },
  OneLineLabelError: {
    ...DefaultVerticalStyle,
    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      height: ListDimens.LIST_CELL_HEIGHT,
      flexDirection: 'row',
      alignItems: 'center',
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      //flex: 1,
      alignSelf: 'center',
      fontWeight: 'FONT_WEIGHT_LIGHT',
    } as TextProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      color: 'RED',
      alignSelf: 'center',
      marginEnd: ListItem.LISTITEM_ONELINE_LABEL_TEXT_MARGIN,
      fontWeight: 'FONT_WEIGHT_MEDIUM',
    } as TextProps,
  },
  ThreeLineFiveLabel: {
    ...DefaultVerticalStyle,
    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      flexDirection: 'row',
    } as BoxProps,

    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      flexDirection: 'column',
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontSize: 'FONT_SIZE_MEDIUM',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      paddingBottom: ListItem.LISTITEM_THREE_LINE_TITLE_TEXT_PADDING,
    } as TextProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      fontSize: 'FONT_SIZE_MEDIUM',
      color: 'SECONDARY_GREY',
    } as TextProps,
  },
  ThreeLineImageCounter: {
    ...DefaultVerticalStyle,
    containerStyle: {
      ...DefaultVerticalStyle.containerStyle,
      borderColor: 'SECONDARY_GREY',
      borderWidth: ListItem.LISTITEM_THREE_LINE_IMAGE_COUNTER_BORDER_WIDTH,
      borderRadius: ListItem.LISTITEM_THREE_LINE_IMAGE_COUNTER_BORDER_RADIUS,
      margin: ListItem.LISTITEM_THREE_LINE_IMAGE_COUNTER_MARGIN,
      paddingVertical: ListItem.LISTITEM_THREE_LINE_IMAGE_COUNTER_PADDING,
      paddingRight: 0,
      alignSelf: 'center',
    } as BoxProps,
    superContainerStyle: {
      ...DefaultVerticalStyle.superContainerStyle,
      marginRight: ListItem.LISTITEM_DEFAULT_VERTICAL_COUNTER_MARGIN,
    } as BoxProps,
    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      marginVertical: ListItem.LISTITEM_DEFAULT_VERTICAL_CONTAINER_MARGIN,
      marginHorizontal: 0,
    } as BoxProps,
    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      flexDirection: 'column',
    } as BoxProps,
    imageContainerStyle: {
      ...DefaultVerticalStyle.imageContainerStyle,
      marginLeft: ListItem.LISTITEM_THREE_LINE_IMAGE_TITLE_MARGIN,
    } as BoxProps,
    imageStyle: {
      borderRadius: ListItem.LISTITEM_THREE_LINE_IMAGE_BORDER_RADIUS,
      width: ListItem.LISTITEM_THREE_LINE_IMAGE_SIZE,
      height: ListItem.LISTITEM_THREE_LINE_IMAGE_SIZE,
    } as ImageProps,
    selectableCounterStyle: {
      width: ListItem.LISTITEM_THREE_LINE_IMAGE_COUNTER_HEIGHT,
      marginTop: ListItem.LISTITEM_THREE_LINE_IMAGE_SELECTABLE_COUNTER_MARGIN,
      alignItems: 'flex-end',
    } as BoxProps,
    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontWeight: 'FONT_WEIGHT_BOLD',
      paddingBottom: ListItem.LISTITEM_TITLETEXT_PADDING,
      fontSize: 'FONT_SIZE_SMALL',
      color: 'BLACK',
    } as TextProps,
    value1TextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      fontSize: 'FONT_SIZE_TINY',
      color: 'SECONDARY_GREY',
      marginTop: ListItem.LISTITEM_THREE_LINE_IMAGE_TITLE_MARGIN,
    } as TextProps,
    value2TextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontWeight: 'FONT_WEIGHT_BOLD',
      fontSize: 'FONT_SIZE_SMALL',
    } as TextProps,
  },
  ThreeLineFiveLabelReverse: {
    ...DefaultVerticalStyle,
    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      flexDirection: 'row-reverse',
    } as BoxProps,

    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      alignItems: 'flex-end',
      flexDirection: 'column',
    } as BoxProps,
    subContent2ContainerStyle: {
      ...DefaultVerticalStyle.subContent2ContainerStyle,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      paddingBottom: ListItem.LISTITEM_TITLETEXT_PADDING,
    } as TextProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontWeight: 'FONT_WEIGHT_BOLD',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
    value3TextStyle: {
      color: 'SECONDARY_GREY',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
  },
  ListFooterAddressItem: {
    ...DefaultVerticalStyle,
    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontSize: 'FONT_SIZE_MEDIUM',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      color: 'PRIMARY_GREY',
      paddingVertical: ListItem.LISTITEM_FOOTER_ADDRESS_PADDING,
    } as TextProps,
  },
  BankListItemStyle: {
    ...DefaultVerticalStyle,
    contentContainerStyle: {
      alignItems: 'center',
      containerStyle: DefaultHorizontalStyle.containerStyle,
      flexDirection: 'row',
    } as BoxProps,
    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      height: ListItem.LISTITEM_BANKLIST_ITEM_HEIGHT,
      // alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontSize: 'FONT_SIZE_LARGE_PLUS',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      color: 'BLACK',
      paddingBottom: ListItem.LISTITEM_BANKLIST_ITEM_TITLETEXT_PADDING,
    } as TextProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontWeight: 'FONT_WEIGHT_BOLD',
      fontSize: 'FONT_SIZE_MEDIUM',
      color: 'SECONDARY_GREY',
    } as TextProps,
  },
  ONELINE_STYLE: {
    ...DefaultVerticalStyle,
    imageContainerStyle: {
      ...DefaultVerticalStyle.imageContainerStyle,
      marginLeft: 0,
      marginRight: 0,
    } as BoxProps,
    imageStyle: {
      ...DefaultVerticalStyle.imageStyle,
      resizeMode: 'contain',
    } as ImageProps,
    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      alignItems: 'center',
      containerStyle: DefaultHorizontalStyle.containerStyle,
      height: HEIGHT.HEIGHT_48,
      flexDirection: 'row',
      flexShrink: 0,
    } as BoxProps,
    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontSize: 'FONT_SIZE_MEDIUM',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      color: 'BLACK',
    } as TextProps,
  },
  ONELINE_STYLE_WITH_IMAGE_PLACEHOLDER: {
    ...DefaultVerticalStyle,
    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      alignItems: 'center',
      containerStyle: DefaultHorizontalStyle.containerStyle,
      height: HEIGHT.HEIGHT_80,
      flexDirection: 'row',
      flexShrink: 0,
    } as BoxProps,
    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontSize: 'FONT_SIZE_MEDIUM',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      color: 'BLACK',
    } as TextProps,
  },
  AddressLine: {
    ...DefaultVerticalStyle,
    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      paddingVertical: ListItem.LISTITEM_ADDRESSLINE_PADDING,
      flexDirection: 'row',
    } as BoxProps,
    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      flexDirection: 'column',
    } as BoxProps,
    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontSize: 'FONT_SIZE_LARGE_2P',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      marginBottom: ListItem.LISTITEM_ADDRESSLINE_TITLETEXT_MARGIN,
    } as TextProps,
    value1TextStyle: {
      ...DefaultVerticalStyle.value1TextStyle,
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      color: 'SECONDARY_GREY',
    } as TextProps,
  },
  FourLabelThreeValue: {
    ...DefaultVerticalStyle,
    contentContainerStyle: {
      ...DefaultVerticalStyle.contentContainerStyle,
      flexDirection: 'row',
    } as BoxProps,
    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      flexDirection: 'column',
    } as BoxProps,

    subContent2ContainerStyle: {
      ...DefaultVerticalStyle.subContent2ContainerStyle,
      marginTop: ListItem.LISTITEM_SUBCONENT_CONTAINER_MARGIN,
    } as BoxProps,
    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      fontWeight: 'FONT_WEIGHT_LIGHT',
      paddingBottom: ListItem.LISTITEM_SUBCONENT_TITLETEXT_PADDING,
    } as TextProps,

    valueTextStyle: {
      ...DefaultVerticalStyle.valueTextStyle,
      fontWeight: 'FONT_WEIGHT_BOLD',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
    value1TextStyle: {
      ...DefaultVerticalStyle.value2TextStyle,
      paddingVertical: ListItem.LISTITEM_SUBCONENT_CONTAINER_PADDING,
      color: 'SECONDARY_GREY',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
    } as TextProps,
    value2TextStyle: {
      ...DefaultVerticalStyle.value2TextStyle,
      paddingVertical: ListItem.LISTITEM_SUBCONENT_CONTAINER_PADDING,
      color: 'SECONDARY_GREY',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
    } as TextProps,
    value3TextStyle: {
      ...DefaultVerticalStyle.value2TextStyle,
      paddingVertical: ListItem.LISTITEM_SUBCONENT_CONTAINER_PADDING,
      fontWeight: 'FONT_WEIGHT_MEDIUM',
    } as TextProps,
    value4TextStyle: {
      ...DefaultVerticalStyle.value2TextStyle,
      paddingVertical: ListItem.LISTITEM_SUBCONENT_CONTAINER_PADDING,
      color: 'SECONDARY_GREY',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
    } as TextProps,
    value5TextStyle: {
      ...DefaultVerticalStyle.value5TextStyle,
      paddingVertical: ListItem.LISTITEM_SUBCONENT_CONTAINER_PADDING,
    } as TextProps,
    value6TextStyle: {
      ...DefaultVerticalStyle.value6TextStyle,
      paddingVertical: ListItem.LISTITEM_SUBCONENT_CONTAINER_PADDING,
    } as TextProps,
  },
  OneLineWithArrow: {
    ...DefaultVerticalStyle,
    containerStyle: {
      width: ListItem.LISTITEM_DEFAULT_VERTICAL_WIDTH,
      paddingHorizontal: ListItem.LISTITEM_DEFAULT_VERTICAL_PADDING,
      height: ListItem.LISTITEM_ONE_LINE_NO_VALUE_HEIGHT,
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'WHITE',
    } as BoxProps,

    imageContainerStyle: {} as BoxProps,

    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      alignItems: 'center',
    } as BoxProps,

    titleTextStyle: {
      ...DefaultVerticalStyle.titleTextStyle,
      color: 'BLACK',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
  },
  OneLineBoldTimeRightArrow: {
    ...DefaultVerticalStyle,
    subContent1ContainerStyle: {
      ...DefaultVerticalStyle.subContent1ContainerStyle,
      alignItems: 'center',
      height: 45,
    } as BoxProps,

    titleTextStyle: {
      color: 'PURE_BLACK',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      fontSize: 'FONT_SIZE_LARGE',
    } as TextProps,
  },
  CarouselRoom: DefaultVerticalStyle,
  Previous: DefaultVerticalStyle,
  Upcoming: DefaultVerticalStyle,
  CarouselRoomTypes: DefaultVerticalStyle,
  UserReview: DefaultVerticalStyle,
  FilterLabel: DefaultVerticalStyle,
}

export default styles
